function firstLetterUpper(theString) {
	var newString = theString.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
  return newString;
}

export const toSentenceCase = (str) => {
  var theString = str
  var newString = firstLetterUpper(theString);
  return newString;
}